module.exports = __webpack_public_path__ + "img/wanily.1e8edeca.png";